//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import UrlUtils from "../utils/url";
import NavDrawerButton from "./drawerButton";
import NavDrawerLabel from "./drawerLabel";
export default {
  components: {
    "nav-drawerButton": NavDrawerButton,
    "nav-drawerLabel": NavDrawerLabel
  },
  // props: ["spec", "trigger", "permanent"],
  props: {
    spec: {
      type: Object,
      required: true
    },
    trigger: {
      type: [Object, Date],
      "default": null
    },
    permanent: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      // Using null as the starting value for its v-model will initialize the drawer as closed on mobile and as open on desktop.
      // See https://vuetifyjs.com/en/components/navigation-drawers
      state: null,
      mini: true,
      shrunk: true
    };
  },
  computed: {
    cssClasses: function cssClasses() {
      // To make sure a css class name is assigned to this component
      this.spec.view = this.spec.view || "pages/leftDrawer";
      return this.$classes();
    },
    style: function style() {
      // Increase z-index so that the drawer is above the page header.
      // return { zIndex: 11 };
      return this.$styles();
    },
    lgAndAbove: function lgAndAbove() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return false;

        default:
          return true;
      }
    }
  },
  watch: {
    trigger: function trigger(val, oldVal) {
      this.state = !this.state;
    }
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.shrunk = this.mini = this.cssClasses.includes("mini"); // this.$el.addEventListener('drawers/clickButton', () => { this.updateState(false) }, false)

      this.$el.addEventListener("drawers/clickButton", function () {
        if (!_this.permanent) {
          _this.updateState(false);
        }
      });
    },
    updateState: function updateState(state) {
      this.state = state;
    },
    expandOnHover: function expandOnHover() {
      return this.mini;
    }
  }
};